// import.meta.env is provided by Vite (dev server & build-time static replacement).
// process.env fallback is kept for any Node.js tooling that might import this file.
//
// IMPORTANT: Vite only statically replaces direct `import.meta.env.X` references.
// Accessing properties via an intermediate variable (e.g. `const e = import.meta.env; e.MODE`)
// will NOT be replaced at build time and will be undefined at runtime.
// Therefore MODE and VITE_APP_VERSION must be read directly from import.meta.env.
const _env = import.meta.env || {}
const _proc = typeof process !== 'undefined' ? process.env : {}

/** @type {('local' | 'dev' | 'staging' | string)} */
export const VUE_APP_VERSION = import.meta.env.VITE_APP_VERSION ?? _proc.APP_VERSION ?? _proc.VITE_APP_VERSION
/** @type {('production' | 'development')} */
export const ENV = import.meta.env.MODE ?? _proc.NODE_ENV
/** @type {string} */
export const VUE_APP_SEMVERSION = extractSemVer(VUE_APP_VERSION)
/** @type {boolean} */
const ENV_DEV = ENV === 'development'
/** @type {boolean} */
export const ENV_DEV_OR_STAGING = ENV_DEV || VUE_APP_VERSION === 'staging'
/** @type {boolean} */
export const ENV_LOCAL = VUE_APP_VERSION === 'local'

export function env(varName, defaultValue) {
	return _env[`VITE_${varName}`] || _proc[`VITE_${varName}`] || defaultValue
}

function extractSemVer(version) {
	if (ENV === 'production' && version?.startsWith('v')) {
		return version.replace('v', '')
	}

	return version
}
